import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--pn-off-white)]" data-testid="site-layout">
      <Header />
      <main className="flex-1" data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
